var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlanTypeBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 9.38666V22.6133C26.6667 24.64 26.48 26.08 26 27.1067C26 27.12 25.9866 27.1467 25.9733 27.16C25.68 27.5333 25.2933 27.72 24.84 27.72C24.1333 27.72 23.28 27.2533 22.36 26.2667C21.2667 25.0933 19.5866 25.1867 18.6266 26.4667L17.28 28.2533C16.7467 28.9733 16.04 29.3333 15.3333 29.3333C14.6267 29.3333 13.92 28.9733 13.3866 28.2533L12.0267 26.4533C11.08 25.1867 9.41332 25.0933 8.31999 26.2533L8.30664 26.2667C6.79997 27.88 5.46669 28.12 4.69336 27.16C4.68003 27.1467 4.66667 27.12 4.66667 27.1067C4.18667 26.08 4 24.64 4 22.6133V9.38666C4 7.35999 4.18667 5.91999 4.66667 4.89332C4.66667 4.87999 4.66669 4.86666 4.69336 4.85332C5.45336 3.87999 6.79997 4.11999 8.30664 5.73332L8.31999 5.74666C9.41332 6.90666 11.08 6.81332 12.0267 5.54666L13.3866 3.74666C13.92 3.02666 14.6267 2.66666 15.3333 2.66666C16.04 2.66666 16.7467 3.02666 17.28 3.74666L18.6266 5.53333C19.5866 6.81332 21.2667 6.90666 22.36 5.73332C23.28 4.74666 24.1333 4.27999 24.84 4.27999C25.2933 4.27999 25.68 4.47999 25.9733 4.85332C26 4.86666 26 4.87999 26 4.89332C26.48 5.91999 26.6667 7.35999 26.6667 9.38666Z",
    stroke: "#10182F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 13.6667H21.3337",
    stroke: "#10182F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 18.3333H18.667",
    stroke: "#10182F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlanTypeBlack);
export default __webpack_public_path__ + "static/media/ic-plan-type-black.21e29174946b7dc80f813982883c5fe3.svg";
export { ForwardRef as ReactComponent };